// Initialize Firebase
import firebase from 'firebase';
var config = {
    apiKey: "AIzaSyANixr4-i1usftYB6RZM2e6O7C8YEKykIc",
    authDomain: "the-open-wall.firebaseapp.com",
    databaseURL: "https://the-open-wall.firebaseio.com",
    projectId: "the-open-wall",
    storageBucket: "the-open-wall.appspot.com",
    messagingSenderId: "40817292856"
  };

firebase.initializeApp(config);

export default firebase;



// WEBPACK FOOTER //
// ./src/Components/firebase.js